import React, { useMemo } from "react";

import { IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import ProjectTable from "pages/components/ProjectTable/ProjectTable";
import MaterialImage from "pages/components/MaterialImage";

function AnaliseVendasMateriaisTable({ materiais, loading, imgsByRef, onAbrirDetalhe }) {
  const columns = useMemo(
    () => [
      {
        Header: "",
        id: "detalhe",
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ row }) => (
          <Tooltip title="Ver detalhe de faturação">
            <IconButton size="small" color="info" onClick={() => onAbrirDetalhe(row.original)}>
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        ),
      },
      {
        Header: "",
        id: "img",
        disableFilters: true,
        disableSortBy: true,
        Cell: ({ row }) => (
          <MaterialImage
            refMaterial={row.original.refmaterial}
            imgsByRef={imgsByRef}
            size={26}
            placeholderWidth={32}
          />
        ),
      },
      {
        Header: "Material",
        id: "material",
        accessor: (row) => {
          const nome = row.nomematerial || "";
          const ref = row.refmaterial || "";

          return `${nome}${ref ? ` (${ref})` : ""}`;
        },
      },
      {
        Header: "Unidade",
        accessor: "unidade",
      },
      {
        Header: "Quantidade",
        accessor: "quantidade",
        Cell: ({ value }) =>
          value == null
            ? ""
            : Number(value).toLocaleString("pt-PT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
      },
      {
        Header: "Valor total",
        accessor: "valortotal",
        Cell: ({ value }) =>
          value == null
            ? ""
            : Number(value).toLocaleString("pt-PT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
      },
      {
        Header: "Litros",
        accessor: "volume",
        Cell: ({ value }) =>
          value == null
            ? ""
            : Number(value).toLocaleString("pt-PT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
      },
      {
        Header: "Peso bruto",
        accessor: "pesobruto",
        Cell: ({ value }) =>
          value == null
            ? ""
            : Number(value).toLocaleString("pt-PT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
      },
      {
        Header: "Faturas",
        accessor: "numerofaturas",
        Cell: ({ value }) => (value == null ? "" : Number(value).toLocaleString("pt-PT")),
      },
      {
        Header: "Clientes",
        accessor: "numeroclientes",
        Cell: ({ value }) => (value == null ? "" : Number(value).toLocaleString("pt-PT")),
      },
      {
        Header: "Fabricante",
        accessor: "fabricante",
      },
      {
        Header: "Família",
        accessor: "familia",
      },
      {
        Header: "Embalagem",
        accessor: "embalagem",
      },
    ],
    [imgsByRef, onAbrirDetalhe]
  );

  const lista = Array.isArray(materiais) ? materiais : [];

  return (
    <ProjectTable
      tableKey="analise-vendas-materiais"
      version="v1"
      title={`Vendas por material (${lista.length.toLocaleString("pt-PT")} materiais)`}
      columns={columns}
      data={lista}
      loading={loading}
      emptyMessage="Sem materiais com os filtros selecionados."
      minWidth={1650}
      maxHeight="58vh"
      defaultSortBy={[
        {
          id: "valortotal",
          desc: true,
        },
      ]}
      showKeepFilters
    />
  );
}

export default AnaliseVendasMateriaisTable;
